import axiosInstance from 'api/axiosInstance';

export interface UpdatePatrolPayload {
  PatrolID: number;
  Status: string;
  Comment: string;
  StartTime: string;
  EndTime: string;
}

export const updatePatrolReport = async (
  payload: UpdatePatrolPayload
): Promise<any> => {
  try {
    // ASMX web services expect the payload wrapped with the parameter name
    const response = await axiosInstance.post(
      '/api/activityreportcontroller/UpdatePatrolReport',
      { payload },
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error('Error updating patrol report:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

export default updatePatrolReport;
